module.exports = __webpack_public_path__ + "static/media/more-label.ef406600.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/more-label.svg
// module id = 768
// module chunks = 0